/** Señal cross-tab + mismo tab: admin guardó site-settings → refetch en useSiteSettings. */
export const SITE_SETTINGS_UPDATED_LS_KEY = "site_settings_updated";
export const SITE_SETTINGS_UPDATED_EVENT = "site-settings-updated";

export function notifySiteSettingsUpdated(): void {
  try {
    localStorage.setItem(SITE_SETTINGS_UPDATED_LS_KEY, String(Date.now()));
  } catch {
    /* no-op */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SITE_SETTINGS_UPDATED_EVENT));
  }
}